// eslint-disable-next-line import/no-unresolved
module.exports = require('./lib/constants');



//////////////////
// WEBPACK FOOTER
// ./~/react-dates/constants.js
// module id = 1499
// module chunks = 4